import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const engagementPost = {
    name: 'kpi.facebook.post_engagement',
    id: 'post_engagements',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    tooltip: 'kpi.facebook.tooltip_post_engagement',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    mergedData: true,
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
